let helper = new Object()

helper.masks = {
  phone: '+7(999)999-99-99',
  email: '*{1,20}@*{1,20}[.*{2,6}]',
  site: '*{4,30}://*{1,100}.*{2,30}'
}

export default helper
